import React from "react";
import './chapter-elo-assessment-report.scss';
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants, Constants } from "../../../../constants/constants";
import Loading from "../../../common/loading/loading";
import SessionCache from "../../../routes/session-cache";
// import { CircularProgressbar } from "react-circular-progressbar";
import ReactTooltip from 'react-tooltip';
import CommonApi from "../../../../apis/common";
import { saveAs } from 'file-saver';
import HomeworkForClickerPracticeApi from "../../../../apis/homework-for-clicker-practice";


const greenColor = '#45CA73'

class ChapterEloAssessmentReport extends React.Component {

    state = {
        // students: [
        //     {
        //         name: "Student 1"
        //     },
        //     {
        //         name: "Student 2"
        //     },
        //     {
        //         name: "Student 3"
        //     },
        //     {
        //         name: "Student 4"
        //     },
        //     {
        //         name: "Student 5"
        //     }
        // ],
        ...this.props.reportData,
        isDownloading: false,
        categories: [
            {
                type: "NOVICE",
                title: "Novice",
                maxPercentage: 50,
                students: [],
                colorClass: "purble-header",
                selectedCriterion: 1
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                minPercentage: 50,
                maxPercentage: 80,
                students: [],
                colorClass: "orange-header",
                selectedCriterion: 1
            },
            {
                type: "ADVANCED",
                title: "Advanced",
                minPercentage: 80,
                students: [],
                colorClass: "litebule-header",
                selectedCriterion: 1
            }
        ],
        // categories: [
        //     {
        //         type: "NOVICE",
        //         title: "Novice",
        //         maxPercentage: 50,
        //         students: [{
        //             studentName: "Class 10",
        //             markScored: 5,
        //             totalMark: 30,
        //             percentage: 17,
        //         }, {
        //             studentName: "Class 10",
        //             markScored: 5,
        //             totalMark: 30,
        //             percentage: 17,
        //         }],
        //         colorClass: "purble-header",
        //         selectedCriterion: 1
        //     },
        //     {
        //         type: "PROFICIENT",
        //         title: "Proficient",
        //         minPercentage: 50,
        //         maxPercentage: 80,
        //         students: [{
        //             studentName: "Class 10",
        //             markScored: 5,
        //             totalMark: 30,
        //             percentage: 17,
        //         }, {
        //             studentName: "Class 10",
        //             markScored: 5,
        //             totalMark: 30,
        //             percentage: 17,
        //         }],
        //         colorClass: "orange-header",
        //         selectedCriterion: 1
        //     },
        //     {
        //         type: "ADVANCED",
        //         title: "Advanced",
        //         minPercentage: 80,
        //         students: [],
        //         colorClass: "litebule-header",
        //         selectedCriterion: 1
        //     }
        // ],
        // noviceStudents: [
        //     {
        //         studentName: "Class 10",
        //         markScored: 5,
        //         totalMark: 30,
        //         percentage: 17,
        //     },
        // ],
        // proficientStudents: [
        // ],
        // advancedStudents: [
        // ],
        // aggregatedQuestionTypeList: [
        //     {
        //         questionType: "CASE_STUDY",
        //         questionTypeName: "Case Study Based Questions",
        //         cleared: 100,
        //         notCleared: 100,
        //         clearedPercentage: 0,
        //         notClearedPercentage: 100,
        //     },
        //     {
        //         questionType: "MCQ",
        //         questionTypeName: "Multiple Choice Questions",
        //         cleared: 0,
        //         notCleared: 0,
        //         clearedPercentage: 0,
        //         notClearedPercentage: 0,
        //     },
        //     {
        //         questionType: "STR",
        //         questionTypeName: "Structured Response Questions",
        //         cleared: 0,
        //         notCleared: 1,
        //         clearedPercentage: 50,
        //         notClearedPercentage: 100,
        //     },
        // ],
        // aggregatedCaseStudySkillReport: [
        //     {
        //         skillName: "Comprehension",
        //         caseStudySkillTitle: "Ability to understand the question",
        //         cleared: 0,
        //         notCleared: 1,
        //         clearedPercentage: 50,
        //         notClearedPercentage: 100,
        //     },
        //     {
        //         skillName: "Modelling",
        //         caseStudySkillTitle: "Ability to apply concepts",
        //         cleared: 0,
        //         notCleared: 1,
        //         clearedPercentage: 0,
        //         notClearedPercentage: 100,
        //     },
        //     {
        //         skillName: "Calculation",
        //         caseStudySkillTitle: "Ability to calculate",
        //         cleared: 0,
        //         notCleared: 1,
        //         clearedPercentage: 100,
        //         notClearedPercentage: 100,
        //     },
        // ],
        // aggregatedCompetencyQustionsGrouping: {
        //     name: "COMPETENCY",
        //     cleared: 0,
        //     notCleared: 1,
        //     clearedPercentage: 50,
        //     notClearedPercentage: 100,
        // },
        // chapterList: [
        //     {
        //         chapterKey: "17200704731054394",
        //         chapterTitle: "Real Numbers",
        //         concepts: [
        //             {
        //                 chapterKey: "17200704731054394",
        //                 chapterTitle: "Real Numbers",
        //                 conceptKey: "17200705377333305",
        //                 conceptTitle: "The Fundamental Theorem of Arithmetic",
        //                 cleared: 0,
        //                 notCleared: 1,
        //                 clearedPercentage: 50,
        //                 notClearedPercentage: 100,
        //             },
        //             // {
        //             //     chapterKey: "17200704731054394",
        //             //     chapterTitle: "Real Numbers",
        //             //     conceptKey: "17200705377333305",
        //             //     conceptTitle: "The Fundamental Theorem of Arithmetic",
        //             //     cleared: 0,
        //             //     notCleared: 1,
        //             //     clearedPercentage: 0,
        //             //     notClearedPercentage: 100,
        //             // },
        //             // {
        //             //     chapterKey: "17200704731054394",
        //             //     chapterTitle: "Real Numbers",
        //             //     conceptKey: "17200705377333305",
        //             //     conceptTitle: "The Fundamental Theorem of Arithmetic",
        //             //     cleared: 0,
        //             //     notCleared: 1,
        //             //     clearedPercentage: 0,
        //             //     notClearedPercentage: 100,
        //             // },
        //             // {
        //             //     chapterKey: "17200704731054394",
        //             //     chapterTitle: "Real Numbers",
        //             //     conceptKey: "17200705377333305",
        //             //     conceptTitle: "The Fundamental Theorem of Arithmetic",
        //             //     cleared: 0,
        //             //     notCleared: 1,
        //             //     clearedPercentage: 0,
        //             //     notClearedPercentage: 100,
        //             // },
        //         ],
        //     },
        //     {
        //         chapterKey: "17200705216289554",
        //         chapterTitle: "Polynomials",
        //         concepts: [
        //             {
        //                 chapterKey: "17200705216289554",
        //                 chapterTitle: "Polynomials",
        //                 conceptKey: "17200705641661252",
        //                 conceptTitle: "Geometrical Meaning of the Zeroes of a Polynomial",
        //                 cleared: 0,
        //                 notCleared: 1,
        //                 clearedPercentage: 0,
        //                 notClearedPercentage: 100,
        //             },
        //             {
        //                 chapterKey: "17200705216289554",
        //                 chapterTitle: "Polynomials",
        //                 conceptKey: "17200705781528154",
        //                 conceptTitle: "Relationship between Zeroes and Coefficients of a Polynomial",
        //                 cleared: 0,
        //                 notCleared: 1,
        //                 clearedPercentage: 0,
        //                 notClearedPercentage: 100,
        //             },
        //         ],
        //     },
        //     {
        //         chapterKey: "17200705288321844",
        //         chapterTitle: "Pair of Linear Equations in Two Variables",
        //         concepts: [
        //             {
        //                 chapterKey: "17200705288321844",
        //                 chapterTitle: "Pair of Linear Equations in Two Variables",
        //                 conceptKey: "17200706079628568",
        //                 conceptTitle: " Algebraic Methods of Solving a Pair of Linear Equations ",
        //                 cleared: 0,
        //                 notCleared: 1,
        //                 clearedPercentage: 0,
        //                 notClearedPercentage: 100,
        //             },
        //         ],
        //     },
        // ],
        // competencyChapterList: [
        //     {
        //         chapterKey: "17200704731054394",
        //         chapterTitle: "Real Numbers",
        //         concepts: [
        //             {
        //                 chapterKey: "17200704731054394",
        //                 chapterTitle: "Real Numbers",
        //                 conceptKey: "17200705377333305",
        //                 conceptTitle: "The Fundamental Theorem of Arithmetic",
        //                 competencyCleared: 1,
        //                 standardCleared: 1,
        //             },
        //         ],
        //     },
        //     {
        //         chapterKey: "17200705216289554",
        //         chapterTitle: "Polynomials",
        //         concepts: [
        //             {
        //                 chapterKey: "17200705216289554",
        //                 chapterTitle: "Polynomials",
        //                 conceptKey: "17200705641661252",
        //                 conceptTitle: "Geometrical Meaning of the Zeroes of a Polynomial",
        //                 competencyCleared: 0,
        //                 standardCleared: 1,
        //             },
        //             {
        //                 chapterKey: "17200705216289554",
        //                 chapterTitle: "Polynomials",
        //                 conceptKey: "17200705781528154",
        //                 conceptTitle: "Relationship between Zeroes and Coefficients of a Polynomial",
        //                 competencyCleared: 0,
        //                 standardCleared: 0,
        //             },
        //         ],
        //     },
        //     {
        //         chapterKey: "17200705288321844",
        //         chapterTitle: "Pair of Linear Equations in Two Variables",
        //         concepts: [
        //             {
        //                 chapterKey: "17200705288321844",
        //                 chapterTitle: "Pair of Linear Equations in Two Variables",
        //                 conceptKey: "17200706079628568",
        //                 conceptTitle: " Algebraic Methods of Solving a Pair of Linear Equations ",
        //                 competencyCleared: 1,
        //                 standardCleared: 1,
        //             },
        //         ],
        //     },
        // ],
        // totalStudents: 14,
    }

    componentDidMount() {
        console.log(this.props.selectedItem)
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })

        this.getStandardCompetencyReport()

    }


    getStandardCompetencyReport() {

        let payload = {
            homeworkId: this.props.selectedItem._id,
            classText: this.props.selectedItem.class,
            board: this.props.selectedItem.board,
            type: this.props.selectedItem.type,
            sectionId: this.props.selectedItem.sectionId,
            masterDataId: this.props.selectedItem.masterDataId,
            duration: this.props.selectedItem.approximateTime
        }

        this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getStandardCompetencyReport(payload).then(res => {
            console.log(res)

            let categories = this.state.categories

            categories.forEach(category => {

                if (category.type === 'NOVICE' && res.noviceStudents && res.noviceStudents.length) {
                    category.students = res.noviceStudents
                }

                if (category.type === 'PROFICIENT' && res.proficientStudents && res.proficientStudents.length) {
                    category.students = res.proficientStudents
                }

                if (category.type === 'ADVANCED' && res.advancedStudents && res.advancedStudents.length) {
                    category.students = res.advancedStudents
                }
            })

            this.setState({ ...res, categories, isLoading: false })

        }).catch(err => {
            console.log(err)
        })
    }


    onClickBack() {
        this.props.close && this.props.close()
    }

    getStudentDiagnosticReportPDF(student) {
        let payload = {
            homeworkId: student.homeworkId,
            userId : student.userId
        }

        HomeworkForClickerPracticeApi.getStudentHomeworkPracticeReportPDF(payload).then(async res => {
            console.log(res)
            saveAs(res.pdfLink, `${student.studentName}.pdf`)

            if (window.electron) {
                this.downloadPDFUsingElectron(res.pdfLink)
            }

            // try {
            //     const response = await fetch(res.pdfLink);
            //     const blob = await response.blob();
            //     saveAs(blob, `${student.studentName}.pdf`);
            //   } catch (error) {
            //     console.error('Error downloading the PDF', error);
            //   }

            // const link = document.createElement('a');
            // link.href = res.pdfLink;
            // link.target = '_blank'
            // link.setAttribute(
            //     'download',
            //     `FileName.pdf`,
            // );
            // // Append to html link element page
            // document.body.appendChild(link);
            // // Start download
            // link.click();
            // // Clean up and remove the link
            // link.parentNode.removeChild(link);
        }).catch(err => {
            console.log(err)
        })

    }

    renderCard(cardInfo, index, minHeightForBorder) {


        return (
            <div className="homework-card" onMouseEnter={ReactTooltip.rebuild}>

                <div className={`homework-card-header py-2 px-2 ${cardInfo.colorClass} `}>
                    <div className='container-1 d-flex align-items-center justify-content-between'>
                        <div>
                            {cardInfo.title}{`${cardInfo.type === 'NOVICE' ? ' (< 50%)' : cardInfo.type === 'PROFICIENT' ? ' (50% - 80%)' : cardInfo.type === 'ADVANCED' ? ' (> 80%)' : ""}`}
                        </div>
                        {
                            this.state.categories[index].students && this.state.categories[index].students.length ?
                                <div className={`d-flex align-items-center`}>
                                    <img className='report-icon  mr-2' src={getImageSource(ImageConstants.WHITE_STUDENTS_COUNT_IMAGE)} />
                                    <span>{this.state.categories[index].students.length}</span>
                                </div>
                                : ""
                        }
                    </div>
                </div>
                <div className="student-list bg-white p-2" style={{
                    height: `${minHeightForBorder * 40}px`,
                    border:
                        `1px solid ${cardInfo.type === 'NOVICE' ? "#FF6464" : cardInfo.type === 'PROFICIENT' ? "#F89D32" : cardInfo.type === 'ADVANCED' ? "#80d2f4" : ""}`
                }}>
                    <div className="">
                        {
                            cardInfo.students?.length ? cardInfo.students.map((student, index) => (
                                <div className="d-flex justify-content-between mb-1">
                                    <div className="student-name">{this.capitalizeWords(student.studentName)} </div>
                                    <div><span className="student-name">{` (${student.percentage}%)`}</span><img className="black_download_icon cursor-pointer" onClick={() => this.getStudentDiagnosticReportPDF(student)} data-tip={`Export to PDF`} src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)} /></div>
                                </div>
                            )) :
                                <div className="text-center" style={{ 'min-width': '400px', fontWeight: '500' }}>No Student </div>}
                    </div>
                </div>
            </div>
        )
    }

    capitalizeWords(input) {
        return input
            .split(' ') // Split the string into an array of words
            .map(word =>
                word
                    .split('.') // Split the word by dots
                    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()) // Capitalize each part
                    .join('.') // Rejoin the parts with dots
            )
            .join(' '); // Join the words back into a single string
    }


    renderCategoryList = () => {

        let minHeightForBorder = ''

        let categories = this.state.categories
        let lengths = []

        for (let i = 0; i < categories.length; i++) {
            let students = categories[i].students
            lengths.push(students.length)
        }

        lengths.sort((a, b) => b - a)

        minHeightForBorder = lengths[0]

        return (
            <div className="category-list mt-4">
                {
                    this.state.categories?.length ? this.state.categories.map((category, index) => (
                        <div className="pr-2">
                            {this.renderCard(category, index, minHeightForBorder)}
                        </div>
                    ))
                        : ""
                }
            </div>
        )
    }

    showStudentCard(type, index, studentsList, statusTitle) {
        if (!studentsList.length) return;
        this.setState({ selectedIndex: index, selectedType: type, students: studentsList, selectedStatusTitle: statusTitle })
    }

    closeStudents() {
        this.setState({ selectedType: null, selectedIndex: -1, students: [], selectedStatusTitle: '', reload: true }, () => {
            this.setState({ reload: false })
        })
    }


    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                {/* <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div> */}

                <div className='position-relative student-card-header-wrapper'>
                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.WRONG)} />
                        </div>
                    </div>
                    <div className='status-title ml-3'>{this.state.selectedStatusTitle}</div>
                </div>

                <div className="min-height-for-student-list">
                    {this.state.students && this.state.students.length ? this.state.students.map((item, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {item.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                    }
                </div>


            </div>
        )
    }


    getQuestionTypeProgressBar(questionTypeList) {
        return (
            <div className="">
                {
                    questionTypeList && questionTypeList.length && questionTypeList.map((item, index) => (
                        <div>
                            <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                                {item.questionTypeName} {` (${item.totalQuestions} Q)`}
                                <div className="d-flex position-relative">
                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.notClearedStudents, "Not Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.notCleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.clearedStudents, "Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.cleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                </div>
                            </div>

                            <div className={`row align-items-center ml-0 mr-0 p-1 ${index === questionTypeList.length - 1 ? "" : "mb-4"}`}>
                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                        {
                                            item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                                <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                            </div>

                        </div>
                    ))
                }
            </div>
        )


    }

    getStandardAndCompetencyQuestionsProgressBar(questionTypeList) {
        return (
            <div className="">
                {
                    questionTypeList && questionTypeList.length && questionTypeList.map((item, index) => (
                        <div>
                            <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                                {item.questionTypeName} {` (${item.totalQuestions} Q)`}
                                <div className="d-flex position-relative">
                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.notClearedStudents, "Not Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.notCleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.clearedStudents, "Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.cleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                </div>
                            </div>

                            <div className={`row align-items-center ml-0 mr-0 p-1 ${index === questionTypeList.length - 1 ? "" : "mb-4"}`}>
                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                    ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                        {
                                            item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                                <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                            </div>

                        </div>
                    ))
                }
            </div>
        )



    }


    getConceptsProgressBar(chapterList) {

        return (
            <div className="">
                {
                    chapterList && chapterList.length && chapterList.map((chapter, cidx) => (
                        <div className="">
                            <div className={`chapter-title mb-2 ${cidx != 0 ? 'mt-3' : ''}`}>{chapter.conceptTitle}</div>
                            <div className=" concept-wrapper">
                                {
                                    chapter.elos && chapter.elos.length && chapter.elos.map((item, index) => (
                                        <>
                                            <div className="mb-1 d-flex align-items-center justify-content-between">
                                                <div className="question-type-name pr-2">{item.eloTitle} {` (${item.totalQuestions} Q)`}</div>
                                                <div className="d-flex position-relative">
                                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.eloId, index, item.notClearedStudents, "Not Cleared Students")}>
                                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                                        <div className="students-count d-flex align-items-center">
                                                            <span>{item.notCleared}</span>
                                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.selectedIndex === index && item.eloId === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                                    }
                                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.eloId, index, item.clearedStudents, "Cleared Students")}>
                                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                                        <div className="students-count d-flex align-items-center">
                                                            <span>{item.cleared}</span>
                                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.selectedIndex === index && item.eloId === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                                    }
                                                </div>
                                            </div>
                                            <div className={`row align-items-center ml-0 mr-0 p-2 ${index === chapter.elos.length - 1 ? "" : "mb-4"}`}>
                                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                                        {
                                                            item.conceptAverage > 0 ? <div className="average-indicator" style={{ left: `${item.conceptAverage}%` }}>
                                                                <div className="average-number-absolute" style={{ left: `${item.conceptAverage}%` }}>{item.conceptAverage}</div>
                                                            </div> : <></>
                                                        }
                                                        {/* <div className="question-type-name question-name-absolute">{item.conceptTitle}</div>
                                                <div className="question-type-name pr-2 mark-text-absolute">{item.markScored}/{item.totalMark}</div> */}
                                                    </div>
                                                </div>
                                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                                            </div>
                                        </>
                                    ))
                                }
                            </div>

                        </div>
                    ))
                }
            </div>
        )
    }

    getChapterList(chapterList) {
        return (
            <div className="">
                {
                    chapterList && chapterList.length && chapterList.map((chapter, cidx) => (
                        <div className="">
                            <div className={`d-flex align-items-center chapter-title-only mb-2 ${cidx != 0 ? 'mt-3' : 'mt-3'}`}><span className="bullet-text">{chapter.conceptTitle}</span></div>
                        </div>
                    ))
                }
            </div>
        )
    }

    getCaseStudySkillQuestionsProgressBar(caseStudySkillList) {
        return (
            <div className="">
                {
                    caseStudySkillList && caseStudySkillList.length && caseStudySkillList.map((item, index) => (
                        <div>
                            <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                                {item.caseStudySkillTitle}{` (${item.totalQuestions} Q)`}
                                <div className="d-flex position-relative">
                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.skillName, index, item.notClearedStudents, "Not Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.notCleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedIndex === index && item.skillName === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.skillName, index, item.clearedStudents, "Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.cleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.selectedIndex === index && item.skillName === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                </div>
                            </div>

                            <div className={`row align-items-center ml-0 mr-0 p-1 ${index === caseStudySkillList.length - 1 ? "" : "mb-4"}`}>
                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                        {
                                            item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                                <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                            </div>

                        </div>
                    ))
                }
            </div>
        )
    }

    getCompetencyProgressBar(item) {
        // console.log(item)
        return (
            <div className="">
                <div>
                    <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                        Competency
                        <div className="d-flex">
                            <div className="d-flex align-items-center"><img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} /><div className="students-count d-flex align-items-center"><span>{item.notCleared}</span> <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} /></div></div>
                            <div className="d-flex align-items-center ml-2"><img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} /><div className="students-count d-flex align-items-center"><span>{item.cleared}</span> <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} /></div></div>
                        </div>
                    </div>

                    <div className={`row align-items-center ml-0 mr-0 p-1`}>
                        <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                            <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                {
                                    item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                        <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                    </div> : <></>
                                }
                            </div>
                        </div>
                        <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                    </div>

                </div>
            </div>
        )
    }

    downloadPDF() {

        let url = this.state.pdfLink

        console.log(url)

        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank'
        link.setAttribute(
            'download',
            `FileName.pdf`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);


        if (window.electron) {
            this.downloadPDFUsingElectron(url)
        }

    }

    downloadAllStudentsReportToPDF() {

        if (this.state.isDownloading) return

        let payload = {
            class: this.state.class,
            section: this.state.sectionName,
            sectionId: this.state.sectionId,
            type: this.state.type,

        }

        if (this.props.homeworkId) {
            payload.homeworkId = this.props.homeworkId ? this.props.homeworkId : null
        }

        this.setState({ isDownloading: true })

        CommonApi.getAllStudentsReportPdf(payload).then((response) => {
            console.log(response)
            // Create a temporary URL for the Blob
            // Create a temporary URL for the Blob

            if (!(response instanceof Blob)) {
                //
                console.log('not a blob')
            }

            // Create a temporary URL for the Blob
            const url = window.URL.createObjectURL(response);

            // Create an anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = this.props.reportType + ' Student Report ' + (new Date).toISOString() + '.zip'; // Name of the downloaded file
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.setState({ isDownloading: false })
            alert('Student Report Downloaded Successfully')

        }).catch(err => {
            this.setState({ isDownloading: false })
            console.log(err)
        })
    }

    downloadPDFUsingElectron(url) {
        window.electron.ipcRenderer.send('download-pdf', {
            payload: {
                fileURL: url
            }
        })
    }






    render() {

        let studentMinPercentage = Math.round(this.state.studentAssessmentTakenCount / 2)


        return (
            <div>
                <div className="chapter-elo-assessment-report">
                    {
                        this.state.isLoading ? <Loading />
                            :
                            <>
                                <div>
                                    <img alt="" className='back-icon cursor-pointer mb-3' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                                </div>
                                <div className="school-name">{this.props.selectedItem.class}{this.props.selectedItem.section ? this.props.selectedItem.section : ''}, Standard Vs Competency Questions Report</div>

                                <div className="d-flex justify-content-between align-items-center  mb-3">
                                    <div className="header-subtext">{this.state?.userInfo?.schoolInfo?.name}</div>
                                    <div className="d-flex ">
                                        <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadPDF()}>Export Overall Report to PDF</div>
                                        {/* <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadAllStudentsReportToPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Export All Students Report to PDF'}</div> */}
                                    </div>
                                </div>

                                <div className="student-basic-details mt-3">
                                    <div className="student-detail-header">Assessment Overview</div>
                                    <div className="student-details-wrapper row mt-3 align-items-center justify-content-between">
                                        <div className="col-3 d-flex align-items-center">
                                            <div className="student-name pr-4 ">Class : <span className="light-text">{this.props.selectedItem.class ? this.props.selectedItem.class.split(' ')[1] : 'Class'} {this.props.selectedItem.section ? this.props.selectedItem.section : ''}</span></div>
                                        </div>
                                        {
                                            this.state.totalStudents ? <div className="student-name col-3  d-flex align-items-center"><span>Total </span> <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />{` : `}<span className="ml-2 light-text">{`${this.state.totalStudents}`}</span> </div> : <></>
                                        }
                                        {
                                            <div className="col-3">
                                                <div className="student-name mr-5 d-flex align-items-center">
                                                    <img className="student-count-image" src={getImageSource(ImageConstants.CLOCK_ICON_GRAY)} />
                                                    <span className="ml-2 mr-1"></span>{` : `}<span className="ml-2 light-text">{`${this.props.selectedItem.approximateTime}mins`}</span>
                                                </div>
                                            </div>
                                        }
                                        {
                                            <div className="col-3">
                                                <div className="student-name mr-5 d-flex align-items-center">
                                                    <img className="student-count-image" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                                    <span className="ml-2 mr-1">Assessed </span>{` : `}<span className="ml-1 light-text">{`${this.state.studentAssessmentTakenCount}`}</span>
                                                </div>
                                            </div>
                                        }




                                        <div className="competency-table mt-4 table-responsive card">
                                            <table className="table table-bordered table-striped" style={{}}>
                                                <thead className="class-header">
                                                    <tr className="first-header-bg">
                                                        <th className="" width='50%'>Question Type</th>
                                                        <th># Questions</th>
                                                        <th>Total Marks</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="rows" className="class-body">
                                                    {
                                                        this.state.standardCompetencyTable &&
                                                        this.state.standardCompetencyTable.length &&
                                                        this.state.standardCompetencyTable.map((item, cidx) => (
                                                            <>
                                                                <tr>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === 2 ? 'bold-text' : ""}`}>
                                                                        {item.questionTypeName}
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === 2 ? 'bold-text' : ""}`}>
                                                                        {item.totalQuestions}
                                                                    </td>
                                                                    <td className={`class-text border-bottom-left-radius ${cidx === 2 ? 'bold-text' : ""}`}>
                                                                        {item.totalMark}
                                                                    </td>
                                                                </tr>
                                                            </>

                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                    <div className="performance-overview mt-3">
                                        <div className="student-detail-header">Concepts Covered</div>
                                        {
                                            this.getChapterList(this.state.chapterList)
                                        }
                                    </div>

                                    <div className="performance-overview mt-3">
                                        <div className="student-detail-header">Student Performance</div>
                                        {
                                            this.renderCategoryList()
                                        }
                                    </div>


                                    <div className="class-overview mt-4">
                                        <div className="student-detail-header">Class Overview</div>
                                        <div className="d-flex justify-content-end mr-5 mt-3">
                                            <div className="d-flex align-items-center">
                                                <img className="image-size mr-1" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                                <img className="student-count-image ml-1 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                                <span className="students-text">Not Cleared{` (Score < 50%)`}</span>
                                            </div>
                                            <div className="d-flex align-items-center ml-4">
                                                <img className="image-size mr-1" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                                <img className="student-count-image ml-1 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                                <span className="students-text">Cleared{` (Score > 50%)`}</span>
                                            </div>
                                        </div>



                                        <div className="mt-4">
                                            <div className="case-study-skill-border-container">
                                                <div className="bordered-text">Standard and Competency Questions</div>
                                                {
                                                    this.getStandardAndCompetencyQuestionsProgressBar(this.state.aggregatedStandardCompetencyList)
                                                }

                                            </div>
                                            {/* <div className="mt-2 mb-5 info-text">#{` Each case study questions has multiple step questions`}</div> */}
                                        </div>

                                        <div className="mt-4 position-relative">
                                            <div className="chapter-list-border-container">
                                                <div className="bordered-text">Learning Outcomewise Performance</div>
                                                {
                                                    this.getConceptsProgressBar(this.state.chapterList)
                                                }
                                            </div>
                                        </div>







                                        <div className="mt-4 position-relative">
                                            <div className="competency-list-border-container">
                                                <div className="bordered-text">Standard VS Competency Questions(Only MCQ)</div>
                                                {/* {
                                                                                    this.getCompetencyProgressBar(this.state.aggregatedCompetencyQustionsGrouping)
                                                                                } */}



                                                <div className="competency-table mt-4  card">
                                                    <table className="table table-bordered table-striped" style={{}}>
                                                        <thead className="class-header">
                                                            <tr className="first-header-bg">
                                                                <th className="" width='50%'>Elos</th>
                                                                <th>Standard</th>
                                                                <th>Competency</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody id="rows" className="class-body">
                                                            {
                                                                this.state.competencyChapterList &&
                                                                this.state.competencyChapterList.length &&
                                                                this.state.competencyChapterList.map((chapter, cidx) => (
                                                                    <>
                                                                        {
                                                                            chapter.concepts && chapter.concepts.length && chapter.concepts.map((item, index) => (
                                                                                <tr>
                                                                                    <td className={`class-text ${chapter.concepts.length - 1 === index ? 'border-bottom-left-radius' : ''}  `}>
                                                                                        {item.eloTitle}
                                                                                    </td>
                                                                                    <td className="position-relative" >
                                                                                        <div className=" d-flex align-items-center cursor-pointer " onClick={() => this.showStudentCard(item.conceptKey, index, item.standardClearedStudents, "Standard Cleared Students")}>
                                                                                            <img className="image-size mr-1" src={getImageSource(item.standardCleared >= studentMinPercentage ? ImageConstants.GREEN_BG_TICK_MARK : ImageConstants.RED_BG_TICK_MARK)} />
                                                                                            <span className="students-text">{item.standardCleared} <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} /></span>
                                                                                        </div>
                                                                                        <div>
                                                                                            {
                                                                                                this.state.selectedIndex === index && item.conceptKey === this.state.selectedType && this.state.selectedStatusTitle === 'Standard Cleared Students' ? this.renderStudentCard() : ""
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="position-relative">
                                                                                        <div className="d-flex align-items-center cursor-pointer " onClick={() => this.showStudentCard(item.conceptKey, index, item.competencyClearedStudents, "Competency Cleared Students")}>
                                                                                            <img className="image-size mr-1" src={getImageSource(item.competencyCleared >= studentMinPercentage ? ImageConstants.GREEN_BG_TICK_MARK : ImageConstants.RED_BG_TICK_MARK)} />
                                                                                            <span className="students-text">{item.competencyCleared} <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} /></span>
                                                                                        </div>
                                                                                        <div>
                                                                                            {
                                                                                                this.state.selectedIndex === index && item.conceptKey === this.state.selectedType && this.state.selectedStatusTitle === 'Competency Cleared Students' ? this.renderStudentCard() : ""
                                                                                            }
                                                                                        </div>
                                                                                    </td>

                                                                                </tr>
                                                                            ))
                                                                        }
                                                                    </>

                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                    </div>



                                </div>


                            </>
                    }

                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div>
        )
    }
}

export default ChapterEloAssessmentReport;